import React, { createContext, useContext } from 'react';

import { PatientDetails } from 'types/PatientCard.types';
import { ReferralPatientDetails } from 'types/PatientList.types';

interface TreatmentContextProps {
  clinicId: string;
  patientDetails?: PatientDetails | ReferralPatientDetails;
  hasShownThreeShapeIntro?: boolean;
  referralId?: string;
}

const TreatmentContext = createContext<TreatmentContextProps | undefined>({
  clinicId: '',
  patientDetails: undefined,
  hasShownThreeShapeIntro: false,
  referralId: undefined
});

export const useTreatmentContext = () => {
  const context = useContext(TreatmentContext);
  if (context === undefined) {
    throw new Error(
      'useTreatmentContext must be used within a TreatmentProvider'
    );
  }
  return context;
};

interface TreatmentProviderProps {
  clinicId: string;
  patientDetails?: PatientDetails | ReferralPatientDetails;
  children: React.ReactNode;
  referralId?: string;
  hasShownThreeShapeIntro?: boolean;
}

export const TreatmentProvider: React.FC<TreatmentProviderProps> = ({
  clinicId,
  patientDetails,
  children,
  hasShownThreeShapeIntro,
  referralId
}) => {
  return (
    <TreatmentContext.Provider
      value={{
        clinicId,
        patientDetails,
        hasShownThreeShapeIntro,
        referralId
      }}
    >
      {children}
    </TreatmentContext.Provider>
  );
};
